import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrawBoundary = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 47,
	viewBox: "0 0 45 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M41.7314 44.8064C41.7314 44.7229 42.1118 44.6533 42.5873 44.6533C43.0628 44.6533 43.4431 44.7229 43.4431 44.8064C43.4431 44.8898 43.0628 44.9594 42.5873 44.9594C42.1118 44.9594 41.7314 44.8898 41.7314 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3027 44.8064C38.3027 44.7229 38.6831 44.6533 39.1586 44.6533C39.6341 44.6533 40.0144 44.7229 40.0144 44.8064C40.0144 44.8898 39.6341 44.9594 39.1586 44.9594C38.6831 44.9594 38.3027 44.8898 38.3027 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8652 44.8064C34.8652 44.7229 35.2456 44.6533 35.7211 44.6533C36.1966 44.6533 36.5769 44.7229 36.5769 44.8064C36.5769 44.8898 36.1966 44.9594 35.7211 44.9594C35.2456 44.9594 34.8652 44.8898 34.8652 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4688 44.8064C31.4688 44.7229 31.8491 44.6533 32.3246 44.6533C32.8001 44.6533 33.1804 44.7229 33.1804 44.8064C33.1804 44.8898 32.8001 44.9594 32.3246 44.9594C31.8491 44.9594 31.4688 44.8898 31.4688 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0068 44.8064C28.0068 44.7229 28.394 44.6533 28.8695 44.6533C29.3449 44.6533 29.7253 44.7229 29.7253 44.8064C29.7253 44.8898 29.3382 44.9594 28.8695 44.9594C28.4008 44.9594 28.0068 44.8898 28.0068 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5732 44.8064C24.5732 44.7229 24.9604 44.6533 25.4359 44.6533C25.9114 44.6533 26.2917 44.7229 26.2917 44.8064C26.2917 44.8898 25.9046 44.9594 25.4359 44.9594C24.9672 44.9594 24.5732 44.8898 24.5732 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1436 44.8064C21.1436 44.7229 21.5307 44.6533 22.0062 44.6533C22.4817 44.6533 22.862 44.7229 22.862 44.8064C22.862 44.8898 22.4749 44.9594 22.0062 44.9594C21.5375 44.9594 21.1436 44.8898 21.1436 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7148 44.8064C17.7148 44.7229 18.102 44.6533 18.5775 44.6533C19.053 44.6533 19.4333 44.7229 19.4333 44.8064C19.4333 44.8898 19.0462 44.9594 18.5775 44.9594C18.1088 44.9594 17.7148 44.8898 17.7148 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2852 44.8064C14.2852 44.7229 14.6723 44.6533 15.141 44.6533C15.6097 44.6533 16.0037 44.7229 16.0037 44.8064C16.0037 44.8898 15.6165 44.9594 15.141 44.9594C14.6655 44.9594 14.2852 44.8898 14.2852 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8555 44.8064C10.8555 44.7229 11.2426 44.6533 11.7113 44.6533C12.18 44.6533 12.574 44.7229 12.574 44.8064C12.574 44.8898 12.1868 44.9594 11.7113 44.9594C11.2358 44.9594 10.8555 44.8898 10.8555 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.42578 44.8064C7.42578 44.7229 7.81295 44.6533 8.28163 44.6533C8.75031 44.6533 9.14428 44.7229 9.14428 44.8064C9.14428 44.8898 8.75711 44.9594 8.28163 44.9594C7.80616 44.9594 7.42578 44.8898 7.42578 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.99316 44.8064C3.99316 44.7229 4.38034 44.6533 4.84902 44.6533C5.3177 44.6533 5.71166 44.7229 5.71166 44.8064C5.71166 44.8898 5.32449 44.9594 4.84902 44.9594C4.37354 44.9594 3.99316 44.8898 3.99316 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58228 43.8318C1.66379 43.8318 1.73171 44.2283 1.73171 44.7083V44.8404L1.58228 44.6944C1.99662 44.6944 2.30907 44.7639 2.30907 44.8404C2.30907 44.917 1.99662 44.9796 1.58228 44.9935H1.43964V44.7083C1.39888 44.1935 1.4668 43.8318 1.58228 43.8318Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 40.2849C1.66551 40.2849 1.73344 40.6814 1.73344 41.1614C1.73344 41.6414 1.66551 42.0448 1.58401 42.0448C1.5025 42.0448 1.43457 41.6483 1.43457 41.1614C1.43457 40.6745 1.46853 40.2849 1.58401 40.2849Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 36.7727C1.66551 36.7727 1.73344 37.1623 1.73344 37.6492C1.73344 38.1361 1.66551 38.5257 1.58401 38.5257C1.5025 38.5257 1.43457 38.1361 1.43457 37.6492C1.43457 37.1623 1.46853 36.7727 1.58401 36.7727Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 33.2585C1.66551 33.2585 1.73344 33.6481 1.73344 34.135C1.73344 34.622 1.66551 35.0115 1.58401 35.0115C1.5025 35.0115 1.43457 34.622 1.43457 34.135C1.43457 33.6481 1.46853 33.2585 1.58401 33.2585Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 29.7466C1.66551 29.7466 1.73344 30.1361 1.73344 30.6231C1.73344 31.11 1.66551 31.4996 1.58401 31.4996C1.5025 31.4996 1.43457 31.11 1.43457 30.6231C1.43457 30.1361 1.46853 29.7466 1.58401 29.7466Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 26.2317C1.66551 26.2317 1.73344 26.6212 1.73344 27.1082C1.73344 27.5951 1.66551 27.9847 1.58401 27.9847C1.5025 27.9847 1.43457 27.5951 1.43457 27.1082C1.43457 26.6212 1.46853 26.2317 1.58401 26.2317Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 22.7212C1.66551 22.7212 1.73344 23.1107 1.73344 23.5977C1.73344 24.0846 1.66551 24.4742 1.58401 24.4742C1.5025 24.4742 1.43457 24.0846 1.43457 23.5977C1.43457 23.1107 1.46853 22.7212 1.58401 22.7212Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 19.2078C1.66551 19.2078 1.73344 19.5973 1.73344 20.0842C1.73344 20.5712 1.66551 20.9607 1.58401 20.9607C1.5025 20.9607 1.43457 20.5712 1.43457 20.0842C1.43457 19.5973 1.46853 19.2078 1.58401 19.2078Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 15.6868C1.66551 15.6868 1.73344 16.0833 1.73344 16.5702C1.73344 17.0572 1.66551 17.4467 1.58401 17.4467C1.5025 17.4467 1.43457 17.0502 1.43457 16.5702C1.43457 16.0902 1.46853 15.6868 1.58401 15.6868Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 12.1743C1.66551 12.1743 1.73344 12.5708 1.73344 13.0578C1.73344 13.5447 1.63155 13.9203 1.58401 13.9203C1.53646 13.9203 1.43457 13.5238 1.43457 13.0438C1.43457 12.5639 1.46853 12.1743 1.58401 12.1743Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 8.6604C1.66551 8.6604 1.73344 9.05691 1.73344 9.54385C1.73344 10.0308 1.63155 10.4412 1.58401 10.4412C1.53646 10.4412 1.43457 10.0447 1.43457 9.56472C1.43457 9.08473 1.46853 8.6604 1.58401 8.6604Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 5.14844C1.66551 5.14844 1.73344 5.54495 1.73344 6.03189C1.73344 6.51882 1.66551 6.90837 1.58401 6.90837C1.5025 6.90837 1.43457 6.51187 1.43457 6.03189C1.43457 5.5519 1.46853 5.14844 1.58401 5.14844Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.80696 1.89963C1.80696 1.94137 1.70508 1.98311 1.54885 2.01094L1.65753 1.89963C1.68727 2.10222 1.7009 2.30694 1.69828 2.51179C1.69828 2.99873 1.63036 3.39522 1.54885 3.39522C1.46734 3.39522 1.39941 2.99873 1.39941 2.51179C1.4002 2.30705 1.41381 2.10258 1.44017 1.89963V1.77441H1.52168C1.70508 1.81615 1.80696 1.85789 1.80696 1.89963Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.23803 1.89962C5.23803 1.9831 4.85085 2.05266 4.38217 2.05266C3.91349 2.05266 3.51953 1.9831 3.51953 1.89962C3.51953 1.81615 3.9067 1.74658 4.38217 1.74658C4.85765 1.74658 5.23803 1.81615 5.23803 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.66776 1.89962C8.66776 1.9831 8.28738 2.05266 7.8119 2.05266C7.33643 2.05266 6.95605 1.9831 6.95605 1.89962C6.95605 1.81615 7.33643 1.74658 7.8119 1.74658C8.28738 1.74658 8.66776 1.81615 8.66776 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0974 1.89962C12.0974 1.9831 11.7171 2.05266 11.2416 2.05266C10.7661 2.05266 10.3857 1.9831 10.3857 1.89962C10.3857 1.81615 10.7661 1.74658 11.2416 1.74658C11.7171 1.74658 12.0974 1.81615 12.0974 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5271 1.89962C15.5271 1.9831 15.1468 2.05266 14.6713 2.05266C14.1958 2.05266 13.8154 1.9831 13.8154 1.89962C13.8154 1.81615 14.1958 1.74658 14.6713 1.74658C15.1468 1.74658 15.5271 1.81615 15.5271 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9558 1.89962C18.9558 1.9831 18.5755 2.05266 18.1 2.05266C17.6245 2.05266 17.2441 1.9831 17.2441 1.89962C17.2441 1.81615 17.6245 1.74658 18.1 1.74658C18.5755 1.74658 18.9558 1.81615 18.9558 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3894 1.89962C22.3894 1.9831 22.0091 2.05266 21.5336 2.05266C21.0581 2.05266 20.6777 1.9831 20.6777 1.89962C20.6777 1.81615 21.0581 1.74658 21.5336 1.74658C22.0091 1.74658 22.3894 1.81615 22.3894 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8191 1.89962C25.8191 1.9831 25.4387 2.05266 24.9633 2.05266C24.4878 2.05266 24.1074 1.9831 24.1074 1.89962C24.1074 1.81615 24.4878 1.74658 24.9633 1.74658C25.4387 1.74658 25.8191 1.81615 25.8191 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2488 1.89962C29.2488 1.9831 28.8684 2.05266 28.393 2.05266C27.9175 2.05266 27.5371 1.9831 27.5371 1.89962C27.5371 1.81615 27.9175 1.74658 28.393 1.74658C28.8684 1.74658 29.2488 1.81615 29.2488 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6843 1.89962C32.6843 1.9831 32.2971 2.05266 31.8217 2.05266C31.3462 2.05266 30.9658 1.9831 30.9658 1.89962C30.9658 1.81615 31.353 1.74658 31.8217 1.74658C32.2903 1.74658 32.6843 1.81615 32.6843 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.114 1.89962C36.114 1.9831 35.7268 2.05266 35.2514 2.05266C34.7759 2.05266 34.3955 1.9831 34.3955 1.89962C34.3955 1.81615 34.7827 1.74658 35.2514 1.74658C35.72 1.74658 36.114 1.81615 36.114 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5476 1.89962C39.5476 1.9831 39.1604 2.05266 38.685 2.05266C38.2095 2.05266 37.8291 1.9831 37.8291 1.89962C37.8291 1.81615 38.2163 1.74658 38.685 1.74658C39.1536 1.74658 39.5476 1.81615 39.5476 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9773 1.89962C42.9773 1.9831 42.5901 2.05266 42.1146 2.05266C41.6392 2.05266 41.2588 1.9831 41.2588 1.89962C41.2588 1.81615 41.646 1.74658 42.1146 1.74658C42.5833 1.74658 42.9773 1.81615 42.9773 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 4.93254C43.3638 4.93254 43.2959 4.53603 43.2959 4.04909C43.2959 3.56215 43.3638 3.17261 43.4453 3.17261C43.5268 3.17261 43.5948 3.56911 43.5948 4.04909C43.5948 4.52908 43.5268 4.93254 43.4453 4.93254Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 8.44646C43.3638 8.44646 43.2959 8.04995 43.2959 7.56301C43.2959 7.07607 43.3638 6.68652 43.4453 6.68652C43.5268 6.68652 43.5948 7.08303 43.5948 7.56301C43.5948 8.04299 43.5268 8.44646 43.4453 8.44646Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 11.9584C43.3638 11.9584 43.2959 11.5619 43.2959 11.075C43.2959 10.588 43.3638 10.1985 43.4453 10.1985C43.5268 10.1985 43.5948 10.595 43.5948 11.075C43.5948 11.555 43.5268 11.9584 43.4453 11.9584Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 15.4714C43.3638 15.4714 43.2959 15.0749 43.2959 14.5949C43.2959 14.1149 43.3638 13.7114 43.4453 13.7114C43.5268 13.7114 43.5948 14.1079 43.5948 14.5949C43.5948 15.0818 43.5268 15.4714 43.4453 15.4714Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 18.9848C43.3638 18.9848 43.2959 18.5883 43.2959 18.1083C43.2959 17.6283 43.3638 17.2249 43.4453 17.2249C43.5268 17.2249 43.5948 17.6214 43.5948 18.1083C43.5948 18.5952 43.5268 18.9848 43.4453 18.9848Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 22.4977C43.3638 22.4977 43.2959 22.1012 43.2959 21.6212C43.2959 21.1413 43.3638 20.7378 43.4453 20.7378C43.5268 20.7378 43.5948 21.1343 43.5948 21.6212C43.5948 22.1082 43.5268 22.4977 43.4453 22.4977Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 26.0102C43.3638 26.0102 43.2959 25.6137 43.2959 25.1337C43.2959 24.6537 43.3638 24.2502 43.4453 24.2502C43.5268 24.2502 43.5948 24.6467 43.5948 25.1337C43.5948 25.6206 43.5268 26.0102 43.4453 26.0102Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 29.5227C43.3638 29.5227 43.2959 29.1332 43.2959 28.6463C43.2959 28.1593 43.3638 27.7698 43.4453 27.7698C43.5268 27.7698 43.5948 28.1593 43.5948 28.6463C43.5948 29.1332 43.5268 29.5227 43.4453 29.5227Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 33.0357C43.3638 33.0357 43.2959 32.6461 43.2959 32.1592C43.2959 31.6723 43.3638 31.2827 43.4453 31.2827C43.5268 31.2827 43.5948 31.6723 43.5948 32.1592C43.5948 32.6461 43.5268 33.0357 43.4453 33.0357Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 36.5491C43.3638 36.5491 43.2959 36.1596 43.2959 35.6726C43.2959 35.1857 43.3638 34.7961 43.4453 34.7961C43.5268 34.7961 43.5948 35.1857 43.5948 35.6726C43.5948 36.1596 43.5268 36.5491 43.4453 36.5491Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 40.0621C43.3638 40.0621 43.2959 39.6725 43.2959 39.1856C43.2959 38.6986 43.3638 38.3091 43.4453 38.3091C43.5268 38.3091 43.5948 38.6986 43.5948 39.1856C43.5948 39.6725 43.5268 40.0621 43.4453 40.0621Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 43.5745C43.3638 43.5745 43.2959 43.185 43.2959 42.698C43.2959 42.2111 43.3638 41.8215 43.4453 41.8215C43.5268 41.8215 43.5948 42.2111 43.5948 42.698C43.5948 43.185 43.5268 43.5745 43.4453 43.5745Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0006 42.7812H41.8965V45.9603H45.0006V42.7812Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10416 43.2207H0V46.3997H3.10416V43.2207Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0006 0H41.8965V3.17901H45.0006V0Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10416 0.314453H0V3.49346H3.10416V0.314453Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4002 18.4237V27.5762C17.8246 27.8212 18.1789 28.1756 18.4239 28.5999H27.5764C27.5764 28.5956 27.5808 28.5912 27.5808 28.5868L27.3839 28.2412L25.9839 25.7912C25.9227 25.7956 25.8614 25.7956 25.8002 25.7956C24.2558 25.7956 23.0002 24.5399 23.0002 22.9956C23.0002 21.4512 24.2558 20.1956 25.8002 20.1956C25.8614 20.1956 25.9227 20.1956 25.9839 20.2L27.3839 17.75L27.5808 17.4043L27.5764 17.3912H18.4239C18.1789 17.8156 17.8246 18.17 17.4002 18.415V18.4237ZM30.0133 27.1999C31.5533 27.2087 32.8002 28.4556 32.8002 30C32.8002 31.5443 31.5446 32.7999 30.0002 32.7999C28.9633 32.7999 28.0577 32.2356 27.5764 31.4H18.4239C17.9383 32.2356 17.0371 32.7999 16.0002 32.7999C14.4558 32.7999 13.2002 31.5443 13.2002 30C13.2002 28.9631 13.7646 28.0575 14.6002 27.5762V18.4237C13.7646 17.9425 13.2002 17.0368 13.2002 16C13.2002 14.4556 14.4558 13.2 16.0002 13.2C17.0371 13.2 17.9427 13.7643 18.4239 14.6H27.5764C28.0621 13.7643 28.9633 13.2 30.0002 13.2C31.5446 13.2 32.8002 14.4556 32.8002 16C32.8002 17.5443 31.5533 18.7912 30.0133 18.8L29.8164 19.1456L28.4164 21.5956L28.3158 21.7706C28.4996 22.1425 28.6002 22.5581 28.6002 23C28.6002 23.4418 28.4996 23.8575 28.3158 24.2293L28.4164 24.4043L29.8164 26.8543L30.0133 27.1999Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.669 31.1647L24.5955 27.0281C24.5165 26.9984 24.4307 26.9921 24.3483 27.0098C24.2658 27.0276 24.1902 27.0687 24.1303 27.1282C24.0705 27.1878 24.0289 27.2633 24.0106 27.3458C23.9922 27.4283 23.9979 27.5144 24.0268 27.5938L28.175 38.7132C28.2072 38.7993 28.2654 38.8732 28.3415 38.9246C28.4176 38.976 28.5077 39.0023 28.5994 38.9998C28.6911 38.9974 28.7798 38.9664 28.8531 38.911C28.9263 38.8557 28.9805 38.7788 29.0082 38.6911L30.194 34.824L34.2143 38.7574C34.2969 38.8397 34.4086 38.8859 34.5251 38.8859C34.6415 38.8859 34.7533 38.8397 34.8359 38.7574L35.8718 37.7188C35.9539 37.636 36 37.524 36 37.4072C36 37.2905 35.9539 37.1785 35.8718 37.0956L31.8647 33.18L35.669 32C35.7556 31.9699 35.8308 31.9136 35.8839 31.8387C35.9371 31.7639 35.9657 31.6743 35.9657 31.5824C35.9657 31.4905 35.9371 31.4009 35.8839 31.326C35.8308 31.2512 35.7556 31.1948 35.669 31.1647Z",
			fill: "black"
		})
	]
});
export default SvgDrawBoundary;
